import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NavWrapper;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Children } from '@instructure/ui-prop-types';
import { ReturnButton } from '../../../common/components/shared/return_button/ReturnButton';
import { NavBar } from '../../../common/components/layout/navbar';
import { SecondaryNavBarButton } from '../../../common/components/layout/navbar/SecondaryNavBarButton';
import { HeaderBreadCrumb } from '../HeaderBreadCrumb';
import { CloseButton, Button } from '@instructure/ui-buttons';
import { BreadcrumbLink } from '@instructure/ui-breadcrumb';
import { IconBankLine } from '@instructure/ui-icons';
import { View } from '@instructure/ui-view';
import { jsx, Global } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var NavWrapper = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NavWrapper = /*#__PURE__*/function (_Component) {
  function NavWrapper() {
    var _this;
    _classCallCheck(this, NavWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NavWrapper, [].concat(args));
    _defineProperty(_this, "setItemBanksRef", function (node) {
      _this.itemBanksRef = node;
    });
    _defineProperty(_this, "setCloseButtonRef", function (node) {
      _this.closeButtonRef = node;
    });
    return _this;
  }
  _inherits(NavWrapper, _Component);
  return _createClass(NavWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var shouldManageFocus = this.props.trayOpen || this.props.navigateToBuild;
      if (!shouldManageFocus) return;
      if (this.closeButtonRef) {
        ReactDOM.findDOMNode(this.closeButtonRef).focus();
      } else if (this.props.navigateToBanks && this.itemBanksRef) {
        ReactDOM.findDOMNode(this.itemBanksRef).focus();
      }
    }
  }, {
    key: "renderReturnButton",
    value: function renderReturnButton() {
      if (!this.props.styles.showReturnButton) {
        return null;
      }
      var _this$props = this.props,
        navigateToBuild = _this$props.navigateToBuild,
        closeTray = _this$props.closeTray,
        returnToUrl = _this$props.returnToUrl,
        iceTopNavBarEnabled = _this$props.iceTopNavBarEnabled;
      if (!closeTray && returnToUrl) {
        return jsx(ReturnButton, {
          returnToUrl: returnToUrl,
          id: "ReturnButton",
          key: "ReturnButton",
          iceTopNavBarEnabled: iceTopNavBarEnabled
        });
      } else if (navigateToBuild) {
        if (iceTopNavBarEnabled) {
          return jsx(SecondaryNavBarButton, {
            id: "ReturnButton",
            key: "ReturnButton",
            variant: "button",
            onClick: navigateToBuild
          }, t('Return'));
        }
        return jsx(Button, {
          onClick: navigateToBuild
        }, t('Return'));
      }
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      if (this.props.closeTray) {
        return jsx(CloseButton, {
          elementRef: this.setCloseButtonRef,
          placement: "start",
          onClick: this.props.closeTray,
          screenReaderLabel: t('Return to quiz')
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.iceTopNavBarEnabled) {
        var actionItems = [this.renderReturnButton()];
        !this.props.isCompact && actionItems.push(this.props.renderHeaderMenu());
        return jsx(NavBar, {
          menuItems: [{
            path: this.props.menuItemPath,
            text: 'Item Banks'
          }],
          actionItems: actionItems
        });
      }
      return jsx(View, null, jsx(Global, {
        styles: {
          'body.tox-fullscreen .nav': {
            display: 'none'
          }
        }
      }), jsx("div", {
        css: this.props.styles.nav
      }, this.renderCloseButton(), jsx("div", {
        css: this.props.styles.crumbs
      }, jsx(HeaderBreadCrumb, {
        returnToUrl: this.props.returnToUrl,
        navigateToBanks: this.props.navigateToBanks,
        navigateToBuild: this.props.navigateToBuild,
        scope: this.props.scope,
        isCompact: this.props.isCompact,
        setItemBanksRef: this.setItemBanksRef,
        renderIcon: jsx(IconBankLine, {
          size: this.props.isCompact ? 'x-small' : null
        })
      }, this.props.children)), this.renderReturnButton(), this.props.renderHeaderMenu()));
    }
  }]);
}(Component), _defineProperty(_NavWrapper, "displayName", 'NavWrapper'), _defineProperty(_NavWrapper, "componentId", "Quizzes".concat(_NavWrapper.displayName)), _defineProperty(_NavWrapper, "propTypes", {
  children: Children.oneOf([BreadcrumbLink]),
  closeTray: PropTypes.func,
  navigateToBanks: PropTypes.func,
  navigateToBuild: PropTypes.func,
  renderHeaderMenu: PropTypes.func,
  trayOpen: PropTypes.bool.isRequired,
  returnToUrl: PropTypes.string,
  scope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  isCompact: PropTypes.bool,
  iceTopNavBarEnabled: PropTypes.bool,
  menuItemPath: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_NavWrapper, "defaultProps", {
  children: null,
  closeTray: null,
  navigateToBanks: null,
  navigateToBuild: null,
  renderHeaderMenu: Function.prototype,
  returnToUrl: null,
  isCompact: false,
  iceTopNavBarEnabled: false,
  menuItemPath: ''
}), _NavWrapper)) || _class);
export default NavWrapper;